import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 9H12.529C12.198 9 11.888 8.836 11.702 8.562L10.297 6.497C10.111 6.224 9.802 6.06 9.471 6.06H5C3.895 6.06 3 6.955 3 8.06V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V11C21 9.896 20.105 9 19 9Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 19V11C21 9.896 20.105 9 19 9H12.529C12.198 9 11.888 8.836 11.702 8.562L10.297 6.497C10.111 6.224 9.802 6.06 9.471 6.06H5C3.895 6.06 3 6.955 3 8.06V19"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 5.94H14.529C14.198 5.94 13.888 5.776 13.702 5.502L12.297 3.437C12.111 3.164 11.802 3 11.471 3H5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
